import styled from "styled-components";

import { truncateText } from "@similarweb/styles";

export const StyledNoSearchResultsFound = styled.div`
    overflow: hidden;
    max-width: 100%;

    & > div {
        padding-left: 16px;
        padding-right: 16px;
    }

    div {
        max-width: 100%;
        box-sizing: border-box;
        ${truncateText()};
    }
`;
